import { Component, computed, effect, input, model, signal, ChangeDetectionStrategy } from "@angular/core";
import type { DisabledReason, FormValueControl, ValidationError, WithOptionalFieldTree } from "@angular/forms/signals";
import { MatAutocompleteModule } from "@angular/material/autocomplete";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatInputModule } from "@angular/material/input";
import { injectCustomerGetById, injectCustomerAutoComplete } from "@jtms/default-connector/angular";
import { computedWith } from "ngx-signal-operators";
@Component({
  selector: "lib-customer-search-control",
  imports: [MatAutocompleteModule, MatFormFieldModule, MatInputModule],
  templateUrl: "./customer-search-control.component.html",
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: "./customer-search-control.component.css",
})
export class CustomerSearchControl implements FormValueControl<string> {
  // Required
  value = model<string>("");

  inputValue = signal<string>("");

  #debouceInputValue = computedWith(this.inputValue).debounce(500);

  getCustomer = injectCustomerGetById(() => ({
    id: this.value(),
  }));

  filteredOptions = injectCustomerAutoComplete(
    () => ({
      query: this.#debouceInputValue(),
    }),
    () => ({ enabled: !!this.inputValue() })
  );

  displayFn(customer: any | null): string {
    return customer ? `${customer.name}` : "";
  }

  // Writable interaction state - control updates these
  touched = model<boolean>(false);
  // Read-only state - form system manages these
  disabled = input<boolean>(false);
  disabledReasons = input<readonly WithOptionalFieldTree<DisabledReason>[]>([]);
  readonly = input<boolean>(false);
  hidden = input<boolean>(false);
  invalid = input<boolean>(false);
  errors = input<readonly ValidationError.WithOptionalFieldTree[]>([]);
}
